var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87891 4.12891L5.29883 7.70898L5.14648 8.97852L6.41602 8.82617L9.99609 5.24609L8.87891 4.12891ZM11.291 5.67773L10.8594 6.10938L7 9.96875L4.99414 10.2227L3.75 10.375L3.90234 9.13086L4.15625 7.125L8.01562 3.26562L8.44727 2.83398L8.87891 2.40234L9.79297 1.48828L10.6562 0.625L11.4941 1.48828L12.6367 2.63086L13.5 3.46875L12.6367 4.33203L11.7227 5.24609L11.291 5.67773ZM10.8594 4.4082L11.7734 3.46875L10.6562 2.35156L9.7168 3.26562L10.8594 4.4082ZM1.10938 2.25H5.57812H6.1875V3.46875H5.57812H1.71875V12.4062H10.6562V8.54688V7.9375H11.875V8.54688V13.0156V13.625H11.2656H1.10938H0.5V13.0156V2.85938V2.25H1.10938Z",
    fill: "#0962AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.16e17d85a3453e77e41489e80216793f.svg";
export { ForwardRef as ReactComponent };